import styled from "styled-components";
import { colors } from "src/theme/colors";
import device from "src/constants/media";
import { typography } from "src/theme";

export const Wrapper = styled.div``;
export const Waves = styled.div`
  position: absolute;
  width: 100%;
  background-image: url("/background/WavesUp.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 888px;
  margin-top: -200px;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  padding-top: 150px;
  padding-bottom: 100px;
  z-index: 1000;
  @media ${device.tablet} {
    padding-top: 200px;
    gap: 48px;
  }
  @media ${device.laptop} {
    padding-top: 400px;
  }
  @media ${device.laptopS} {
    padding-left: 0;
    padding-right: 0;
    width: 1096px;
    margin: 0 auto;
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  place-content: flex-end;
  position: relative;

  ::after {
    content: url("/doodle/doodle-double-line.svg");
    position: absolute;
    top: 0;
    right: -75%;
  }
  @media ${device.laptop} {
    ::after {
      top: -10px;
      right: -110px;
    }
  }
  @media ${device.laptopS} {
    ::after {
      top: 24px;
      right: -120px;
    }
  }
`;
export const CardsWrapper = styled.div`
  & .slick-slide {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-right: 24px;

    & :last-child {
      margin-right: 0;
    }
  }
  & .slick-track {
    display: flex;
  }
  @media ${device.mobileM} {
    & .slick-list {
      overflow: unset;
    }
  }
  @media ${device.laptopS} {
    & .slick-list {
      overflow: hidden;
    }
  }
`;
export const SliderCardWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  height: 96px;
  padding: 20px;
  background-color: ${colors.white};
  box-shadow: 0px 8px 64px -32px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;

  :hover {
    background-color: ${colors.mainVeryLight};
  }
`;
export const ImageContainer = styled.div`
  min-width: 56px;
`;
